import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { MapService } from 'src/app/Services/map.service';
import { SharedService } from 'src/app/Services/shared.service';

declare var google: any;
@Component({
  selector: 'app-map-tracking',
  templateUrl: './map-tracking.component.html',
  styleUrls: ['./map-tracking.component.css']
})
export class MapTrackingComponent implements OnInit {

  @Input() set filterDate(val:any){
    if(val){
      this.selFilteredDate=val;
      this.getEmployeeList(val);
    }
  }
  @Input() set branchChoosen(val:any){
    if(val){
      this.choosenBranch=val;
      if(this.selFilteredDate==undefined){
        this.getEmployeeList();
      }else{
        this.getEmployeeList(this.selFilteredDate);
      }
    }else{
      this.choosenBranch=[];
    }
  }
  public fleetData:any=[];
  public choosenBranch:any=[];
  public selFilteredDate:number;
  public empStatusObj:any={
    "boarded" : "Boarded",
    "reschedule":"Reschedule",
    "noShow":"No show",
    "noNeed":"No need",
    "deboarded":"Deboarded",
    "notUtilized":'No show'
  }
  
  @Input() gMapId:any='googleMapChart';

  public mapOptions = {
    scrollwheel: true,
    zoom: 9,
    maxZoom: 22,
    center: new google.maps.LatLng(13.0843, 80.2705),
    fullscreenControl: false,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP,
    },
    mapTypeControl: true,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.TOP_CENTER,
    },
    streetViewControl: false,
  };
  constructor(
    private api: ApiService,
    private com: CommonServices,
    private mapService: MapService,
    private share: SharedService,
  ) { }
 


  public selectedMap:string='google';
  public googleMapObj: any;
  // public locationMap: any;
  ngOnInit(): void {
    setTimeout(()=>{
      this.loadMap();
    },10)
  }
  loadMap() {
    if(this.selectedMap=='google'){
      setTimeout(()=>{
        const mapOptions = {
          scrollwheel: true,
          zoom: 9,
          maxZoom: 17,
          center: new google.maps.LatLng(13.0843, 80.2705),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('gMapId'), mapOptions);
      },100)
    }else{
      this.mapService.map("locationMap").then((map) => {
        this.gMapId = map;
      }).catch((error) => {
        console.log(error)
      });
    }
  }
  showNestedData(id){
    setTimeout(()=>{
      let btn=document.getElementById(id);
      if(btn.classList.contains('fa-chevron-down')){
          btn.classList.replace('fa-chevron-down','fa-chevron-up');
          btn.title='Hide employee';
        }else{
          btn.classList.replace('fa-chevron-up','fa-chevron-down');
          btn.title='Show employee';
      }
    },100)
  }
  convertTimeStr(ms){
    let d = new Date(ms),
    h = (d.getHours()<10?'0':'') + d.getHours(),
    m = (d.getMinutes()<10?'0':'') + d.getMinutes();
    return h + ':' + m;
  }
  getEmployeeList(date?) {
    let apiObj={
      rosterStatus:['Fleet management']
    };
    apiObj['branchID']=this.choosenBranch;
    let currentDate=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
    if(this.selFilteredDate==undefined || this.selFilteredDate==currentDate){
      apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
      apiObj['istoday']=true;
    }else{
      apiObj['tripDate']=this.selFilteredDate;
      apiObj['istoday']=false;
    }
    this.api.transportManagerGrouping(apiObj).then(async(res:any)=>{
      if (res && res.status == 'success') {
        if(res.data[0]['fleetManagment'] && res.data[0]['fleetManagment'].length>0){
          this.fleetData= await this.com.sortGroupByShiftTime(res.data[0]['fleetManagment'],'shiftTime');
          // this.storedData=JSON.parse(JSON.stringify(res.data[0]['fleetManagment']));
        }else{
          this.fleetData=[];
        }
      }else{
        this.fleetData=[];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
